
define(
	'Tavanoteam.ProductSpecifications.ProductSpecification'
	, [
		'Tavanoteam.ProductSpecifications.ProductSpecification.View'
		, 'Tavanoteam.ProductSpecifications.Documents'
		, 'Handlebars'
	]
	, function (
		ProductSpecificationView
		, ProductSpecificationsDocuments
		, Handlebars
	) {
		'use strict';

		Handlebars.registerHelper('ifEquals', function (arg1, arg2, options) {
			return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
		});

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');

				if (layout) {
					layout.registerView('ProductSpecifications', function () {
						return new ProductSpecificationView({ container: container });
					});
				}

				ProductSpecificationsDocuments.mountToApp(container);
			}
		};
	});
